// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__KnD+G","form-title":"Common_form-title__WG2rL","form-actions":"Common_form-actions__d3t-R"};